@if (isVisible) {
<div class="add-field-modal-overlay" (click)="onClose()">
  <div class="add-field-modal-container" (click)="stopPropagation($event)">
    <div class="add-field-modal-header">
      <h2>{{ 'Add' | translate }} {{ 'Field' | translate }}</h2>
      <button class="add-field-modal-close-btn" (click)="onClose()" [attr.aria-label]="'Close' | translate">
        <span class="icon-close">&times;</span>
      </button>
    </div>
    <form class="add-field-modal-body" [formGroup]="addFieldForm" (ngSubmit)="onSaveSubmit()">
      <div class="form-group">
        <app-generic-selector [config]="fieldSelectorConfig" formControlName="field" [label]="'Field' | translate"
          [placeholder]="'Select field' | translate">
        </app-generic-selector>
      </div>
      <div class="form-group">
        <label class="form-label" for="add-field-culture">{{ 'Crop' | translate }}</label>
        <select id="add-field-culture" class="form-input" formControlName="culture">
          <option [ngValue]="null">{{ 'SELECT_CROP' | translate }}</option>
          @for (crop of availableCrops; track crop.id) {
          <option [value]="crop.id">
            {{ crop | serverTranslate:'names' }}
          </option>
          }
        </select>
        @if (addFieldForm.get('field')?.value && availableCrops.length === 0) {
        <small style="color: #999; margin-top: 4px; display: block;">
          {{ 'No crops found for this field' | translate }}
        </small>
        }
      </div>
    </form>
    <div class="add-field-modal-footer">
      <button class="btn btn-secondary" (click)="onClose()">{{ 'Cancel' | translate }}</button>
      <button class="btn btn-primary" (click)="onSaveSubmit()" [disabled]="addFieldForm.invalid">
        {{ 'Save' | translate }}
      </button>
    </div>
  </div>
</div>
}
